var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ancient-breakdown-map"}},[_c('div',{attrs:{"id":"mglBreakdownMap"}}),(_vm.modalObject.showModal)?_c('GeoMapDetailModal',{attrs:{"modalObject":_vm.modalObject}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }